import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminStore } from "../utils/store";

export default function AdminProtectedRoute({ children }) {
  const { user } = useAdminStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user.isAuthenticated || user.role !== "admin") {
      navigate("/adminLogin", {
        replace: true,
        state: {
          from: location.pathname + location.search,
        },
      });
    }
  }, [user, navigate, location]);

  if (!user.isAuthenticated || user.role !== "admin") {
    return null;
  }

  return children;
}
